/**
 * This
 * script runs after Boost renders/refreshes the grid, reads each product's
 * variants (cached) to find the largest discount, and appends a saving badge:
 *   - "X% OFF"        when every on-sale variant shares the same discount
 *   - "Up to X% OFF"  when the discount varies across variants (price range)
 * It also rewrites the strikethrough/compare price to the highest
 * compare-at price across all variants (Boost only shows the selected
 * variant's compare-at, which can be lower than the sale range max).
 *
 * Red styling is handled by boost.scss; the red "Sale" badge is pure CSS.
 */
(function () {
  'use strict';

  var productCache = {};

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fetchProduct(handle) {
    if (productCache[handle]) {
      return productCache[handle];
    }

    productCache[handle] = fetch(root() + 'products/' + handle + '.js')
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .catch(function () {
        return null;
      });

    return productCache[handle];
  }

  function computeSaving(product) {
    var maxDiscount = 0;
    var minDiscount = 100;
    var maxCompare = 0;
    var onSale = false;
    var variants = (product && product.variants) || [];

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var compare = variant.compare_at_price || 0;

      if (compare > variant.price) {
        onSale = true;

        if (compare > maxCompare) {
          maxCompare = compare;
        }

        var discount = Math.round(((compare - variant.price) * 100) / compare);

        if (discount > maxDiscount) {
          maxDiscount = discount;
        }
        if (discount < minDiscount) {
          minDiscount = discount;
        }
      } else {
        minDiscount = 0;
      }
    }

    return {
      onSale: onSale,
      maxDiscount: maxDiscount,
      maxCompare: maxCompare,
      varies: minDiscount !== maxDiscount,
    };
  }

  // Matches Boost's display format: thousands separators, no decimals for
  // whole-dollar amounts (e.g. $1,206), two decimals otherwise (e.g. $262.99).
  function formatMoney(cents) {
    var hasCents = cents % 100 !== 0;
    return '$' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: hasCents ? 2 : 0,
    });
  }

  function getHandle(item) {
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) {
      return null;
    }

    var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function applyLabel(item, label) {
    var wrapper = item.querySelector('.boost-sd__product-price-wrapper');
    if (!wrapper) {
      return;
    }

    var existing = wrapper.querySelector('.boost-sd__product-price--saving');

    if (existing) {
      if (existing.textContent.trim() !== label) {
        existing.textContent = label;
      }
      existing.classList.add('saving-badge--sale');
      return;
    }

    var badge = document.createElement('span');
    badge.className = 'boost-sd__product-price--saving saving-badge--sale';
    badge.setAttribute('aria-hidden', 'true');
    badge.textContent = label;
    wrapper.appendChild(badge);
  }

  // Boost renders the compare-at (strikethrough) price of the selected/first
  // variant only; per design it must be the highest compare-at across variants.
  function applyComparePrice(item, maxCompare) {
    var compareEl = item.querySelector('.boost-sd__format-currency--price-compare');
    if (!compareEl) {
      return;
    }

    var target = compareEl.querySelector('.boost-sd__format-currency') || compareEl;
    var formatted = formatMoney(maxCompare);

    if (target.textContent.trim() !== formatted) {
      target.textContent = formatted;
    }
  }

  function processItem(item) {
    if (!item.querySelector('.boost-sd__product-price--sale')) {
      return;
    }

    var handle = getHandle(item);
    if (!handle) {
      return;
    }

    fetchProduct(handle).then(function (product) {
      if (!product) {
        return;
      }

      var info = computeSaving(product);

      if (!info.onSale || info.maxDiscount <= 0) {
        return;
      }

      var label = (info.varies ? 'Up to ' : '') + info.maxDiscount + '% OFF';
      applyLabel(item, label);

      if (info.maxCompare > 0) {
        applyComparePrice(item, info.maxCompare);
      }
    });
  }

  function scan() {
    var items = document.querySelectorAll('.boost-sd__product-item');
    for (var i = 0; i < items.length; i++) {
      processItem(items[i]);
    }
  }

  function init() {
    scan();

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) {
        return;
      }
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        scan();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('load', scan);
    setTimeout(scan, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
